import React, { FC } from 'react';
import styled from 'styled-components';

import { ScreenReaderOnly } from '../ScreenReaderOnly';

const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const Image = styled.img`
  border-radius: 50%;
`;

interface IProps {
  'data-testid'?: string;
  imgUrl: string;
  size?: number;
  userName: string;
  userRole?: string;
  title?: boolean;
  showText?: boolean;
}

export const UserBadge: FC<IProps> = ({
  imgUrl,
  size = 35,
  userName,
  userRole = 'Assignee',
  'data-testid': testId,
  title = true,
  showText,
}) => (
  <UserWrapper data-testid={testId}>
    <ScreenReaderOnly>{userRole}</ScreenReaderOnly>
    <Image
      className="fitProfileImage roundFramePhoto fitProfileImage"
      src={imgUrl}
      width={`${size}`}
      height={`${size}`}
      title={title ? userName : undefined}
    />
    {showText ? <>&nbsp;{userName}</> : null}
  </UserWrapper>
);
